
import { FC } from 'react';

interface UKFlagProps {
  className?: string;
}

const UKFlag: FC<UKFlagProps> = ({ className = "w-5 h-4" }) => {
  return (
    <svg
      className={className}
      viewBox="0 0 20 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="UK flag"
    >
      <rect width="20" height="16" fill="#012169" />
      <path d="M0 0L20 16M20 0L0 16" stroke="white" strokeWidth="1.5" />
      <path d="M0 0L20 16M20 0L0 16" stroke="#C8102E" strokeWidth="1" />
      <path d="M8 0L8 16M0 6L20 6" stroke="white" strokeWidth="3" />
      <path d="M10 0L10 16M0 8L20 8" stroke="#C8102E" strokeWidth="2" />
    </svg>
  );
};

export default UKFlag;
